import React, { useEffect } from "react";
import PropTypes from "prop-types";
import EngineConfigForm from "./EngineConfigForm";
import "./engine-config-modal.css";

const EngineConfigCreateModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="engine-config-modal"
      role="dialog"
      aria-modal="true"
      onClick={onClose}>
      <div className="engine-config-modal-panel" onClick={(e) => e.stopPropagation()}>
        <EngineConfigForm variant="modal" onClose={onClose} />
      </div>
    </div>
  );
};

EngineConfigCreateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default EngineConfigCreateModal;
